const Section2 = () => {
  return (
    <div className="space-y-6 lg:space-y-10 lg:w-[90%] mx-auto">
      <h1 className="text-sm lg:text-xl text-center font-bold">
        The Kitehawk Program provides students with:
      </h1>
      <ul className="list-disc list-inside px-5 text-sm lg:text-base">
        <li>
          The skills required to learn words independently, including spelling
          skills, dictionary skills, and
        </li>
        <li>
          An understanding of the basic structure of the English language. The
          program assumes students know the alphabet but have a sparse knowledge
          of phonics. The program does not assume students know how to spell
          many of the small important words. (e.g. are, you, and, was,  etc). 
          It is written in plain English and covers basic grammar and
          punctuation. The free website is available as a resource for the
          teachers and parents of students who use the workbooks.  
        </li>
      </ul>
      <h1 className="text-sm lg:text-xl font-bold text-center">
        Features of the Online and Print Program
      </h1>
      <p className="px-5 text-sm lg:text-base">
        There are 4 Programs in the Online Program, each containing about 30
        Units.  Each Unit averages about ten to eleven Activities, totalling
        about 1370 Activities.  Programs 2, 3 and 4 have a total of 18 Spelling
        Review Units, or about 300 multiple choice questions.
        <br />
        The Print program or workbooks, vary between 92 – 104 pages.  Each
        Program contains about 30 units, with a word list and exercises based on
        the word list. The number of new words studied at each program is the
        same as in the Online Program: Program 1 (370), Program 2 (580), Program
        3 (600) and Programs 4 & 5 (700 each).
        <br />
        Core, or ‘Must Know’ words used in writing are identified at the start
        of each program. They are a list of high frequency words used by the
        student in up to 75% of their daily writing.
        <br />
        Many important words are repeated in subsequent units and programs.
        <br />
        Each unit contains Activities to develop spelling skills and literacy. 
        The Activities focus strongly on the list words. The Program does not
        involve time-consuming photocopying, distribution, loose paper files,
        and wastage of paper, thus minimising expenses and wasted time.
        <br />
        Students will need a school dictionary to develop the dictionary skills
        required, to complete many of the Online and Print Activities.  These
        skills will enable them to work independently. The Oxford School
        Dictionary, or a similar dictionary preferably with Latin and Greek
        roots, is recommended.  A dictionary covering the list words is included
        in Programs 1 and 2 workbooks, to help develop basic dictionary skills.
        <br />
        The ability to read, understand and follow instructions, is an important
        intellectual skill that this program develops. The instructions for each
        exercise are quite specific and are designed to make students think
        about the answers required.  
      </p>

      <h1 className="text-sm lg:text-xl font-bold text-center">Website</h1>
      <p className="px-5 text-sm lg:text-base">
        The website contains support material for the Kitehawk Learning Spelling
        & Literacy Program. Material available includes Answers, Dictation,
        Spelling Review Tests and games to improve literacy. <br /> Various
        articles provide information on the basic skills, to improve literacy. 
        These include spelling skills and rules, dictionary skills, listening
        skills, syllables, suffixes, synonyms, antonyms, compound words and
        plurals of nouns. A Feedback facility is also provided for comments and
        suggestions from you, to improve the usefulness of the online version
        and future editions of the workbooks.  
      </p>
      <h1 className="text-sm lg:text-xl font-bold text-center">New Editions</h1>
      <p className="px-5 text-sm lg:text-base">
        As part of our continuous improvement program, print editions are
        revised before each reprint and new versions of the Online program are
        uploaded and available automatically.
      </p>
    </div>
  );
};

export default Section2;
